import { render, staticRenderFns } from "./buyShopSearch.vue?vue&type=template&id=1b20f37f&scoped=true"
import script from "./buyShopSearch.vue?vue&type=script&lang=js"
export * from "./buyShopSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b20f37f",
  null
  
)

export default component.exports